import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunkMiddleware from "redux-thunk";
import rootReducer from "../reducersStore";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage: storage, 
  /*	whitelist: ['auth'],
	blacklist: ['pagination']*/
};

const middlewares = [thunkMiddleware];
const persistedReducer = persistReducer(persistConfig, rootReducer);
 
const store = () => {
  let md = applyMiddleware(...middlewares);
  if (process.env.NODE_ENV === "development") {
    md = composeWithDevTools(applyMiddleware(...middlewares));
  }
  //const store = createStore(reducers, initialState, applyMiddleware(thunk));
  let store = createStore(persistedReducer, md);
  let persistor = persistStore(store);
  return { store, persistor };
};
export default store;
